import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import MobileTabBar from '../components/layout/MobileTabBar';

const LayoutDefault = ({ children, invertHeader = true }) => (
  <React.Fragment>
    <Header className={invertHeader ? "invert-color" : ""} navPosition="right" />
    <main className="site-content">
      {children}
    </main>
    <Footer />
    {typeof window !== 'undefined' && localStorage.getItem('accessToken') && <MobileTabBar />}
  </React.Fragment>
);

export default LayoutDefault;  